<section class="personal_info_sec">
  <form class="form-section" autocomplete="off" (ngSubmit)="updateProfile()">
    <div class="custom-tabs">
      <mat-tab-group [@.disabled]="true">
        <!-- Basic Info-TAB -->
        <mat-tab>
          <ng-template mat-tab-label>
            Basic Info
          </ng-template>
          <!-- TABS-BODY -->
          <section class="tabs-body">
            <form [formGroup]="signUpDetailsForm" class="form-section">
              <section class="profile_min_heightbox">
                <div class="tabs_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                  fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
                  <div class="column basic_data mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                    fxFlex.xs="100" fxFlexFill>
                    <!-- First-Name-INPUT -->
                    <div class="custom-form-group">
                      <label class="custom-label" for="">Name<span class="star">*</span></label>
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <input matInput placeholder="Enter your name" readonly formControlName="name">
                          <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                          <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                        </mat-form-field>
                      </div>
                    </div>
                    <!-- PHone No-INPUT -->
                    <div class="custom-form-group">
                      <label class="custom-label" for="">Phone No<span class="star">*</span></label>
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <input type="text" matInput placeholder="Enter your phone number" formControlName="phone">
                          <mat-icon matSuffix class="profile_edit" (click)="openField()">
                            <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                          </mat-icon>
                          <!-- <mat-error *ngIf="phone.invalid && ( phone.dirty || phone.touched )"> <span>Phone No is
                          required</span>
                      </mat-error> -->
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="column basic_data" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                    fxFlex.xs="100" fxFlexFill>
                    <!-- Email-INPUT -->
                    <div class="custom-form-group">
                      <label class="custom-label" for="">Email<span class="star">*</span></label>
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <input type="email" matInput placeholder="Enter your email" readonly formControlName="email">
                          <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                          <!-- <mat-error *ngIf="email.invalid && ( email.dirty || email.touched )"> <span>Email is
                          required</span>
                      </mat-error> -->
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="0px">
                <div class="submits_btns" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
                  fxFlexFill fxLayoutAlign="end end">
                  <button (click)="changePhone()" [disabled]="phoneBlock" class="btn btn-sm global-btn profile_save_btn"
                    mat-button>Submit</button>
                </div>
              </div>
            </form>
          </section>
        </mat-tab>
        <!--  Personal Details -->
        <mat-tab>
          <ng-template mat-tab-label>
            Personal Details
          </ng-template>
          <!-- TABS-BODY -->
          <section class="tabs-body personal_details_tabbody">
            <!-- <app-profile></app-profile> -->
            <!-- PROFILE-IMAGES -->
            <div class="profile_data" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
              fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="15px">
              <div class="column" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100" fxFlexFill
                *ngIf="token?.type =='PROFESSIONAL'">
                <span>Image1</span>
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" (change)="onSelectFileDp(fileVable.files)" #fileVable (click)="$event.stopPropagation()" />
                    <label for="imageUpload"></label>
                    <!-- <mat-progress-spinner [diameter]="25" [value]="progress" *ngIf="progress > 0">
                  </mat-progress-spinner> -->
                  </div>
                  <div class="avatar-preview">
                    <div id="imagePreview">
                      <img *ngIf="!userDisplay?.profile_image"
                      src="../../../../../assets/images/empty-imgs/empty-user-image.png"
                        alt="img" />
                      <img *ngIf="userDisplay?.profile_image"
                        onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/empty-user-image.png";'
                        [src]="userDisplay?.profile_image?.url" alt="img" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="column profile_col" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65"
                fxFlex.xs="100" fxFlexFill *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'">
                <span class="avatar_label">Business Logo</span>
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input type='file'  id="imageUpload" accept=".png, .jpg, .jpeg" (change)="onSelectFileDp(fileVable.files)" #fileVable (click)="$event.stopPropagation()" />
                    <label for="imageUpload"></label>
                    <!-- <mat-progress-spinner [diameter]="25" [value]="progress" *ngIf="progress > 0">
                  </mat-progress-spinner> -->
                  </div>
                  <div class="avatar-preview">
                    
                    <div id="imagePreview">
                      <img *ngIf="!userDisplay?.logo"
                       src="../../../../../assets/images/empty-imgs/business_logo_placeholder.svg"
                        alt="img" />
                      <img *ngIf="userDisplay?.logo"
                        onerror='this.onerror=null;this.src="../../../../../assets/images/empty-imgs/business_logo_placeholder.svg";'
                        [src]="userDisplay?.logo?.url" alt="img" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form [formGroup]="subscriberDetailForm" class="form-section">
              <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
                <div *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'"
                  class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
                  fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Select type-INPUT -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Select type*<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select any type" [disabled]="butDisabled" formControlName="salutation">
                          <mat-option disabled=""> Select gender </mat-option>
                          <mat-option [value]="'Mr'">Mr.</mat-option>
                          <mat-option [value]="'Mrs'">Mrs.</mat-option>
                          <mat-option [value]="'Ms'">Ms.</mat-option>
                          <mat-option [value]="'Dr'">Dr.</mat-option>
                        </mat-select>
                        <!-- <mat-error *ngIf="salutation.invalid && ( salutation.dirty || salutation.touched )">
                      <span>Please provide a valid type</span>
                    </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Middle Name -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Middle Name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter middle Name" readonly formControlName="middle_name">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Date of Birth -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Date of Birth
                      <span class="star" style="display: inline-block !important;">*</span>
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="DD/MM/YYYY" readonly [matDatepicker]="picker"
                          formControlName="dob">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <!-- <mat-error *ngIf="dob.invalid && ( dob.dirty || dob.touched )">
                            <span>Date of birth is
                              required</span>
                          </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'"
                  class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
                  fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- First Name -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">First Name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter First Name"  formControlName="first_name">
                        <!-- <mat-icon matSuffix>
                                            <img src="../../../../../assets/images/icons/check.svg" alt="">
                                          </mat-icon> -->
                        <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                                            required</span>
                                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Last Name -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Last Name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter last Name"  formControlName="last_name">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="fName.invalid && ( fName.dirty || fName.touched )"> <span>First name is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Gender -->
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Gender
                      <span class="star" style="display: inline-block !important;">*</span>
                    </label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select any type" [disabled]="butDisabled" formControlName="gender">
                          <mat-option disabled=""> Select gender </mat-option>
                          <mat-option [value]="'male'">Male</mat-option>
                          <mat-option [value]="'female'">Female</mat-option>
                          <mat-option [value]="'other'">Other</mat-option>
                        </mat-select>
                        <!-- <mat-error *ngIf="gender.invalid && ( gender.dirty || gender.touched )">
                          <span>Please provide a valid value</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Email-INPUT -->
                  <!-- Password-INPUT -->
                  <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Password<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Password" formControlName="password">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error *ngIf="password.invalid && ( password.dirty || password.touched )">
                        <span>Password is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
                </div>
              </div>
              <div class="personal_details_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
                <div *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'"
                  class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
                  fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Lst-Name-INPUT -->
                  <div class="custom-form-group " *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'">
                    <label class="custom-label" for="">Business Name</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter business Name" readonly formControlName="businessName">
                        <!-- <mat-error *ngIf="businessName.invalid && ( businessName.dirty || businessName.touched )">
                      <span>Business Name is
                        required</span>
                    </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group " *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'">
                    <label class="custom-label" for="">ABN / ACN Number</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter business Name" readonly formControlName="ABN_ACN_number">
                        <!-- <mat-error *ngIf="businessName.invalid && ( businessName.dirty || businessName.touched )">
                    <span>Business Name is
                      required</span>
                  </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div *ngIf="token?.type =='SUPPLIER' || token?.type =='PRACTICE'"
                  class="personal_details_column mobile_mb_0" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
                  fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Gender*<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select any type" readonly formControlName="gender">
                          <mat-option disabled=""> Select gender </mat-option>
                          <mat-option [value]="'male'">Male</mat-option>
                          <mat-option [value]="'female'">Female</mat-option>
                          <mat-option [value]="'other'">Other</mat-option>
                        </mat-select>
                        <!-- <mat-error *ngIf="gender.invalid && ( gender.dirty || gender.touched )">
                  <span>Please provide a valid value</span>
                </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group" *ngIf="token?.type !=='SUPPLIER' && token?.type !=='PRACTICE'">
                    <label class="custom-label" for="">Date of Birth</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="DD/MM/YYYY" readonly [matDatepicker]="picker"
                          formControlName="dob">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <!-- <mat-error *ngIf="dob.invalid && ( dob.dirty || dob.touched )">
                <span>Date of birth is
                  required</span>
              </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!-- PHone No-INPUT -->
                <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Phone No<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input type="number" matInput placeholder="Enter Phone No" formControlName="phone">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error *ngIf="phone.invalid && ( phone.dirty || phone.touched )"> <span>Phone No is
                          required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
                <!-- Confirm-Password-INPUT -->
                <!-- <div class="custom-form-group">
                  <label class="custom-label" for="">Confirm Password<span class="star">*</span></label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="Enter Confirm Password" formControlName="confirmPassword">
                      <mat-icon matSuffix>
                        <img src="../../../../../assets/images/icons/check.svg" alt="">
                      </mat-icon>
                      <mat-error
                        *ngIf="confirmPassword.invalid && ( confirmPassword.dirty || confirmPassword.touched )">
                        <span>Confirm Password is required</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->
              </div>
            </form>
            <!-- <div class="" fxLayout="column" fxLayoutAlign="center center">
              <button class="btn btn-sm global-btn profile_save_btn" mat-button>Submit</button>
            </div> -->
          </section>
        </mat-tab>
        <!-- Contact Information -->
        <mat-tab>
          <ng-template mat-tab-label>
            Contact Information
          </ng-template>
          <!-- TABS-BODY -->
          <section class="tabs-body">
            <form [formGroup]="contactInformationForm" class="form-section">
              <div class="contact_numbers" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px">
                <div class="column col_contacts mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                  fxFlex.xs="100" fxFlexFill>
                  <!-- Alternate email-INPUT -->
                  <div class="custom-form-group " *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">first name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter first name" readonly formControlName="fName">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )"> <span>Country is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">last name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter last name"  formControlName="lName">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )"> <span>Country is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">business phone number<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter business phone number" formControlName="businessPhoneNumber">
                        <mat-icon matSuffix class="profile_edit" (click)="buzzPhone()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Alternate email<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Alternate email" formControlName="altEmail">
                        <mat-icon matSuffix class="profile_edit" (click)="altMail()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="altEmail.invalid && ( altEmail.dirty || altEmail.touched )"> <span>Alternate
                            email is required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Address<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter address"  formControlName="address">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Address Line 2<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <textarea matInput  placeholder="Enter Address Line 2"
                          formControlName="address_line_two"> </textarea>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="addLine2.invalid && ( addLine2.dirty || addLine2.touched )"> <span>Address
                            Line 2 is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Landmark<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Landmark"  formControlName="land_mark">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">State<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter State"  formControlName="state">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="state.invalid && ( state.dirty || state.touched )"> <span>State is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="column col_contacts mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                  fxFlex.xs="100" fxFlexFill>
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">middle name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter middle name"  formControlName="mName">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )"> <span>Country is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">business email<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter business email" formControlName="businessEmail">
                        <mat-icon matSuffix class="profile_edit" (click)="buzzEmail()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">fax number<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter fax number"  formControlName="faxNumber">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="landmark.invalid && ( landmark.dirty || landmark.touched )"> <span>Landmark is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Alternate Phone number<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="altPhone" matInput placeholder="Enter Alternate Phone number"
                          formControlName="altPhoneNo">
                        <mat-icon matSuffix class="profile_edit" (click)="altPhone()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="altPhone.invalid && ( altPhone.dirty || altPhone.touched )"> <span>Alternate
                            Phone number is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Address Line 1-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Address Line 1<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <textarea matInput placeholder="Enter Address Line 1" 
                          formControlName="address_line_one"> </textarea>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="addLine1.invalid && ( addLine1.dirty || addLine1.touched )"> <span>Address
                            Line 1 is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- landmark-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">City<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter City"  formControlName="city">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="city.invalid && ( city.dirty || city.touched )"> <span>City is required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- state-INPUT -->
                  <!-- Zip Code-INPUT -->
                  <!-- Alternate Phone number-INPUT -->
                  <!-- Address Line 2-INPUT -->
                  <!-- city-INPUT -->
                  <!-- country-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Country<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Country"  formControlName="country">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="country.invalid && ( country.dirty || country.touched )"> <span>Country is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Zip Code<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Zip Code"  formControlName="zipcode">
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="zipCode.invalid && ( zipCode.dirty || zipCode.touched )"> <span>Zip Code is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
                *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill>
                  <div class="account_branch">
                    <div class="or">
                      <span>Secondary Contact Info</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="second_contact" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="50px"
                *ngIf="token?.type =='SUPPLIER'|| token?.type =='PRACTICE'">
                <div class="column second_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
                  fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Contact name-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Contact name</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter contact name"  formControlName="contactName">
                        <!-- <mat-error *ngIf="contactName.invalid && ( contactName.dirty || contactName.touched )">
                        <span>Contact name is required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Phone Number-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Phone Number</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter phone number"  formControlName="phoneNoTwo">
                        <!-- <mat-error *ngIf="phoneNoTwo.invalid && ( phoneNoTwo.dirty || phoneNoTwo.touched )">
                        <span>Phone number is required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="column second_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
                  fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Email Address
                  -INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Email Address</label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter email address"  formControlName="emailTwo">
                        <!-- <mat-error *ngIf="emailTwo.invalid && ( emailTwo.dirty || emailTwo.touched )">
                        <span>Email is required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="submit_btn_row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="0px">
                <div class="submits_btns" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
                  fxFlexFill fxLayoutAlign="end end">
                  <button (click)="changeContact()" class="btn btn-sm global-btn profile_save_btn"
                    >Submit</button>
                </div>
              </div>
              <!-- <div class="" fxLayout="column" fxLayoutAlign="center center">
              </div> -->
            </form>
          </section>
        </mat-tab>
        <!-- Professional Details -->
        <mat-tab>
          <ng-template mat-tab-label>
            Professional Details
          </ng-template>
          <!-- TABS-BODY -->
          <section class="tabs-body">
            <form [formGroup]="professionalDetailsForm" class="form-section">
              <div class="flex-wrap professional_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row"
                fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center stretch"
                fxLayoutGap="50px">
                <div class="column professional_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
                  fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Profession Type-SELECT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Profession Type<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter profession type" readonly formControlName="professionType">
                        <!-- <mat-error *ngIf="drivingLicense.invalid && ( drivingLicense.dirty || drivingLicense.touched )">
                          <span>Driving License is
                            required</span>
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- APHRA Registration Number-INPUT -->
                  <div class="custom-form-group" *ngIf="token?.type =='PROFESSIONAL'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">APHRA Registration Number<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter APHRA Registration Number" readonly
                          formControlName="pro_details_aphra_registration_number">
                        <!-- <mat-error *ngIf="regNumber.invalid && ( regNumber.dirty || regNumber.touched )"> <span>APHRA
                          Registration Number is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="column professional_column mobile_mb_0" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30"
                  fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
                  <!-- Driving License -->
                  <div class="custom-form-group" *ngIf="token?.type =='PROFESSIONAL'|| token?.type =='PRACTICE'">
                    <label class="custom-label" for="">Driving License<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Driving License" readonly formControlName="drivingLicense">
                        <!-- <mat-error *ngIf="drivingLicense.invalid && ( drivingLicense.dirty || drivingLicense.touched )">
                        <span>Driving License is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- TGA -->
                  <div class="custom-form-group" *ngIf="token?.type =='SUPPLIER'">
                    <label class="custom-label" for="">TGA<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Driving License" readonly formControlName="tga">
                        <!-- <mat-error *ngIf="drivingLicense.invalid && ( drivingLicense.dirty || drivingLicense.touched )">
                        <span>Driving License is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </mat-tab>
        <!-- Other Info -->
        <mat-tab>
          <ng-template mat-tab-label>
            Other Info
          </ng-template>
          <!-- TABS-BODY -->
          <section class="tabs-body">
            <form [formGroup]="otherDetailsForm" class="form-section">
              <div class="sell-header">
                <div class="custom-slide-toggle" *ngIf="token?.type =='SUPPLIER'">
                  <span>Dou you want to sell supplies</span>
                  <mat-slide-toggle formControlName="sellProducts"></mat-slide-toggle>
                </div>
                <div class="custom-slide-toggle">
                  <span>Dou you want to sell 2nd Hand supplies</span>
                  <mat-slide-toggle [(ngModel)]="userDisplay.second_hand" formControlName="sellSecondHandSupplies"></mat-slide-toggle>
                </div>
              </div>
              <!-- <h4 class="bg-line-heading">Bank Details</h4> -->
              <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" *ngIf="userDisplay?.second_hand"
                fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill>
                  <div class="account_branch">
                    <div class="or">
                      <span>Bank Details</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="account_row" *ngIf="userDisplay?.second_hand" fxLayout="row" fxLayout.xl="row"
                fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
                fxLayoutAlign="center stretch" fxLayoutGap="50px">
                <div class="column account_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                  fxFlex.xs="100" fxFlexFill>
                  <!-- bankName-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Bank Name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Bank Name" formControlName="bank_name">
                        <mat-icon matSuffix class="profile_edit" (click)="bankOne()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="bankName.invalid && ( bankName.dirty || bankName.touched )"> <span>Bank Name is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- accountNumber-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Account Number<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Account Number" formControlName="account_number">
                        <mat-icon matSuffix class="profile_edit" (click)="bankThree()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="accountNumber.invalid && ( accountNumber.dirty || accountNumber.touched )">
                        <span>Account Number is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="column account_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
                  fxFlex.xs="100" fxFlexFill>
                  <!-- Account Holder Name-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">Account Holder Name<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter Account Holder Name" formControlName="account_holder_name">
                        <mat-icon matSuffix class="profile_edit" (click)="bankTwo()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="regNumber.invalid && ( regNumber.dirty || regNumber.touched )"> <span>Account
                          Holder Name is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- bsb-INPUT -->
                  <div class="custom-form-group">
                    <label class="custom-label" for="">BSB<span class="star">*</span></label>
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input matInput placeholder="Enter BSB" formControlName="bsb">
                        <mat-icon matSuffix class="profile_edit" (click)="bankFour()">
                          <img src="../../../../../assets/images/icons/action_icons/edit.svg" alt="">
                        </mat-icon>
                        <!-- <mat-icon matSuffix>
                          <img src="../../../../../assets/images/icons/check.svg" alt="">
                        </mat-icon> -->
                        <!-- <mat-error *ngIf="bsb.invalid && ( bsb.dirty || bsb.touched )"> <span>BSB is
                          required</span>
                      </mat-error> -->
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="row" *ngIf="userDisplay?.second_hand" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                fxLayout.xs="column" fxLayoutAlign="center stretch" fxLayoutGap="0px">
                <div class="submits_btns" fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="65" fxFlex.xs="100"
                  fxFlexFill fxLayoutAlign="end end">
                  <button (click)="changeBank()" class="btn btn-sm global-btn profile_save_btn"
                    mat-button [disabled]="bankOneBlock">Submit</button>
                </div>
              </div>
            </form>
          </section>
        </mat-tab>
      </mat-tab-group>
    </div>
  </form>
</section>
